import { PopFeatureFlagsDto } from './pop-feature-flags.dto';

export class Flags {
  public static readonly deactivateModelDropdownStructure: keyof PopFeatureFlagsDto =
    'deactivateModelDropdownStructure';
}
